import * as React from 'react';

import { CommonIconProps } from 'shared/entities/components/Icon';

import BaseIcon from '../BaseIcon';

const ImageIcon: React.FC<CommonIconProps> = (props: CommonIconProps) => {
  return (
    <BaseIcon
      {...props}
      proportion={48 / 44}
      svgProps={{
        viewBox: '0 0 48 44',
        fill: 'none'
      }}
    >
      <rect
        x="3"
        y="5"
        width="42"
        height="34"
        rx="2.5"
        fill="currentColor"
        fillOpacity="0.1"
        stroke="currentColor"
        strokeOpacity="0.2"
        strokeWidth="2"
      />
      <circle cx="36" cy="14" r="5" fill="currentColor" fillOpacity="0.18" />
      <path
        d="M7 33L16 21L25 29L33 17L41 33"
        fill="currentColor"
        fillOpacity="0.15"
        stroke="currentColor"
        strokeOpacity="0.3"
        strokeWidth="2"
        strokeLinejoin="round"
      />
    </BaseIcon>
  );
};

export default ImageIcon;
